module.exports = __webpack_public_path__ + "img/gtm-doc.jpg_w545.017de986.jpg";